<template>
  <div class="page-form">
    <div id="cart_content_div" class="table-responsive">
      <table id="cart_contents" class="table table-vcr">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Order Date</th>
            <th>Email Address</th>
            <th>Total Cost</th>
            <th>Credit Card</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ orderDetails.orderID }}</td>
            <td>{{ orderDetails.orderDate | formatDate }}</td>
            <td>{{ orderDetails.deliveryEmail }}</td>
            <td>{{ orderDetails.totalCost | formatCurrency }}</td>
            <td>*{{ orderDetails.last4cc }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Receipt",
  computed: {
    orderDetails() {
      return this.$store.getters["cart/orderDetails"];
    },
    totalPrice() {
      return this.$store.getters["cart/totalPrice"];
    }
  }
};
</script>
